//routes
import authRoutes from "./auth.routes"
import dashboardRoutes from "./dashboard.routes"
import canauxRoutes from "./canaux.routes"
import iaRoutes from "./ia.routes"
import dossierRoutes from "./dossier.routes"
import administrerRoutes from "./administrer.routes"
import meRoutes from "./me.routes"

const routes = [
    authRoutes,
    dashboardRoutes,
    canauxRoutes,
    iaRoutes,
    dossierRoutes,
    administrerRoutes,
    meRoutes,
  

];

export default routes;

